import * as React from "react";

export interface TestCommentsCount {
    id: string;
    count: number;
}

export interface InterpretationsSelectorProps {
    testId: string;
    selectedInterpretationsCount: Array<TestCommentsCount>;
    onInterpretationClick: () => void;
    selectedAlertsCount: Array<TestCommentsCount>;
    onAlertClick: () => void;
}

export const InterpretationsSelector = ({ testId, selectedInterpretationsCount, onInterpretationClick, selectedAlertsCount, onAlertClick }: InterpretationsSelectorProps) => {
    return (
        <>
            <button className="btn btn-primary" onClick={() => onInterpretationClick()}>
                Analysis Interpretations&nbsp;
                <span className="badge badge-info">{selectedInterpretationsCount.length > 0 ? selectedInterpretationsCount.find(x => x.id === testId).count : null}</span>
            </button>&nbsp;
            <button className="btn btn-primary" onClick={() => onAlertClick()}>
                Alerts&nbsp;
                <span className="badge badge-info">{selectedAlertsCount.length > 0 ? selectedAlertsCount.find(x => x.id === testId).count : null}</span>
            </button>
        </>
    );
}
